// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-projects-container {
    width: 100%;
    max-width: 1050px;
    margin: auto;
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.emp-tabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
    border-bottom: 2px solid #ddd;
}

.emp-sub-heading {
    text-align: left;
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
}

.emp-tab {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    color: gray;
    position: relative;
}

.emp-tab.emp-active {
    color: black;
}

.emp-tab.emp-active::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: blue;
    bottom: 0;
    left: 0;
}

.emp-projects-table {
    margin-top: 20px;
}

.table {
    width: 100%;
    border-collapse: collapse;
    background: white;
}

.th, .td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/EmpProjectTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":[".emp-projects-container {\n    width: 100%;\n    max-width: 1050px;\n    margin: auto;\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.emp-tabs {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n    border-bottom: 2px solid #ddd;\n}\n\n.emp-sub-heading {\n    text-align: left;\n    margin-left: 10px;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.emp-tab {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n    color: gray;\n    position: relative;\n}\n\n.emp-tab.emp-active {\n    color: black;\n}\n\n.emp-tab.emp-active::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 3px;\n    background-color: blue;\n    bottom: 0;\n    left: 0;\n}\n\n.emp-projects-table {\n    margin-top: 20px;\n}\n\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n}\n\n.th, .td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
